import { useCallback, useRef, useState } from "react";
import { EMPTY_UNSAVED_ENTITY_DETAIL_SUMMARY } from "../utils/entityDetailLeaveGuard";

export function useUnsavedEntityDetailLeaveGuard() {
  const [summary, setSummary] = useState(EMPTY_UNSAVED_ENTITY_DETAIL_SUMMARY);
  const [dialogOpen, setDialogOpen] = useState(false);
  const pendingActionRef = useRef(null);

  const requestLeave = useCallback(
    (action) => {
      if (!summary?.hasUnsaved) {
        action?.();
        return;
      }
      pendingActionRef.current = action;
      setDialogOpen(true);
    },
    [summary?.hasUnsaved]
  );

  const stayOnPage = useCallback(() => {
    setDialogOpen(false);
    pendingActionRef.current = null;
  }, []);

  const leaveWithoutSaving = useCallback(() => {
    setDialogOpen(false);
    const action = pendingActionRef.current;
    pendingActionRef.current = null;
    action?.();
  }, []);

  return {
    summary,
    setSummary,
    dialogOpen,
    requestLeave,
    stayOnPage,
    leaveWithoutSaving,
  };
}

/** @deprecated Use useUnsavedEntityDetailLeaveGuard */
export const useUnsavedRelationshipLeaveGuard = useUnsavedEntityDetailLeaveGuard;
